<template>
	<div class="detail-section">
		<div class="header">
			<span>{{ projectMarker.name }}</span>
			<div v-if="isSupport === true" @click="isDisabled === false ? isExternal = !isExternal : null">
				<span>Externe partij</span>
				<ToggleField :checked="isExternal" :enabled="isDisabled === false"></ToggleField>
			</div>
		</div>
		<form v-if="isExternal === false" @submit.prevent="onSubmitMainForm" class="main-form">
			<ExecutionAppointmentProjectLine
				@formChanged="setMainFormData"
				:main-form-data="mainFormData"
				:main-project="projectMarker"
				:key="mainProductProjectLine.id" :project-line="mainProductProjectLine"
				:is-main-project-line="true"
				:vans="vans"
				:is-reschedule="isReschedule || isDisabled"
				:is-support="isSupport"
				:is-disabled="isDisabled"
				ref="mainProjectLine"
			></ExecutionAppointmentProjectLine>
			<ExecutionAppointmentProjectLine
				v-if="isSupport === false || projectLine.product_id === 58"
				v-for="(projectLine, index) in projectLines"
				@formChanged="setMainFormData"
				:main-form-data="mainFormData"
				:main-project="projectMarker"
				:key="projectLine.id" :project-line="projectLine"
				:is-main-project-line="false"
				:vans="projectLine.product_id !== 53 ? vans : vansWithVentilatieroosters"
				:is-reschedule="isReschedule || isDisabled"
				:is-support="isSupport"
				:is-disabled="isDisabled"
				ref="projectLines"
			></ExecutionAppointmentProjectLine>
			<span v-if="shouldShowHoogwerkerWarning" class="warning">ANNULEER DE HOOGWERKER VOOR {{ this.formatDate(currentHoogwerkerDate, 'DD-MM-YYYY') }}</span>
			<textarea name="notes-input" id="notes-input" rows="4" v-model="notes" :disabled="isDisabled"
					  placeholder="Notitie tijdens het maken van de afspraak..."></textarea>
			<div class="form-actions">
				<div v-if="mainProductProjectLine.product_id === 331 && projectMarker.additionalProjects.length > 0">
					FTX1 direct inplannen
					<ToggleField
						:checked="shouldPlanFTX1"
						:enabled="isDisabled === false"
						@change="shouldPlanFTX1 = !shouldPlanFTX1"
					></ToggleField>
				</div>
				<Button v-if="!isDisabled" :primary="true" type="submit" ref="submitMainButton">Maak afspraak</Button>
			</div>
		</form>
		<form v-if="isExternal === true " @submit.prevent="onSubmitExternalForm" class="external-form">
			<div class="input-container">
				<DateField id="date-input-external" placeholder="01-01-2022" v-model="externalFormData.external_date" :disabled="isDisabled" value-format="yyyy-mm-dd"></DateField>
				<span class="error-message" v-if="isExternalFormValid === false">Mag niet leeg zijn</span>
			</div>
			<textarea name="external-notes-input" id="external-notes-input" rows="4" v-model="notes" :disabled="isDisabled"
					  placeholder="Notitie tijdens het maken van de afspraak..."></textarea>
			<Button v-if="!isDisabled" :primary="true" type="submit" ref="submitExternalButton">Opslaan</Button>
		</form>
	</div>
</template>

<script>
import {client} from "@/store";
import Button from "./Button";
import ExecutionAppointmentProjectLine from "./ExecutionAppointmentProjectLine";
import ExecutionAppointmentAdditionalProject from "./ExecutionAppointmentAdditionalProject";
import {mapActions, mapMutations} from "vuex";
import moment from "moment";
import ToggleField from "./ToggleField";
import DateField from "./DateField";
import ExecutionAppointmentCreateModal from "./ExecutionAppointmentCreateModal";

export default {
	name: "ExecutionAppointmentCreateForm",

	components: {
		ToggleField,
		DateField,
		Button,
		ExecutionAppointmentProjectLine,
		ExecutionAppointmentAdditionalProject
	},

	props: {
		projectMarker: Object,
		isReschedule: Boolean,
		isSupport: {
			type: Boolean,
			default: false
		},
		supportTicket: Object,
		isDisabled: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			isExternal: false,
			vans: [],
			vansWithVentilatieroosters: [],
			notes: '',
			currentHoogwerkerDate: null,
			mainProductProjectLine: null,
			projectLines: [],
			mainFormData: {
				main: {
					main_date_1: '',
					main_date_2: ''
				},
				hoogwerker: {
					date_hoogwerker: "",
					extra_date_hoogwerker: ""
				}
			},
			externalFormData: {
				external_date: ''
			},
			isExternalFormValid: true,
			shouldShowHoogwerkerWarning: false,
			shouldPlanFTX1: false,
			bodemIsolatieProductIds: [
				217, 	//Bodemisolatie HR++ ThermoEPSÂ® +/-25cm Rbf: 5,96 mÂ² K/W
				55, 	//Bodemisolatie HR++ ThermoEPSÂ® 15,5cm Rbf: 3,69 mÂ² K/W
				145, 	//Bodemisolatie HR++ ThermoEPSÂ® 17,5cm Rbf: 4,16 mÂ² K/W
				88,  	//Bodemisolatie HR++ ThermoEPSÂ® 20cm Rbf: 4,77 mÂ² K/W
				152 	//Bodemisolatie HR++ ThermoEPSÂ® 30 cm Rbf: 7.16 mÂ² K/W
			],
			ftx1ProductIds: [
				298, 	//Spouwmuurisolatie FTX1Â® +/- 10 cm. Rd: 2,93
				300, 	//Spouwmuurisolatie FTX1Â® +/- 11 cm. Rd: 3.23
				299, 	//Spouwmuurisolatie FTX1Â® +/- 12 cm. Rd: 3.52
				305, 	//Spouwmuurisolatie FTX1Â® +/- 15 cm. Rd: 4,40
				323, 	//Spouwmuurisolatie FTX1Â® +/- 18 cm. Rd: 5,28
				310, 	//Spouwmuurisolatie FTX1Â® +/- 4cm. Rd: 1,14
				294, 	//Spouwmuurisolatie FTX1Â® +/- 5cm. Rd: 1,47
				273, 	//Spouwmuurisolatie FTX1Â® +/- 8cm. Rd: 2,35
				295, 	//Spouwmuurisolatie FTX1Â® +/- 7cm. Rd: 2,05
				296, 	//Spouwmuurisolatie FTX1Â® +/- 8cm. Rd: 2,35
				297 	//Spouwmuurisolatie FTX1Â® +/- 9 cm. Rd: 2,64
			],
			leeghalenProductIds: [
				331,	//Leeghalen spouwmuren
			],
			thermofoamProductIds: [
				226, 	//Spouwmuurisolatie ThermoFoam LTE +/- 10 cm. Rd: 3,03
				251, 	//Spouwmuurisolatie ThermoFoam LTE +/- 11 cm. Rc: 3.33
				243, 	//Spouwmuurisolatie ThermoFoam LTE +/- 12 cm. Rc: 3.63
				244, 	//Spouwmuurisolatie ThermoFoam LTE +/- 13 cm. Rc: 3.94
				290, 	//Spouwmuurisolatie ThermoFoam LTE +/- 14 cm. Rc: 4,24
				263, 	//Spouwmuurisolatie ThermoFoam LTE +/- 15 cm. Rc: 4.55
				268, 	//Spouwmuurisolatie ThermoFoam LTE +/- 16 cm. Rc: 4,85
				324, 	//Spouwmuurisolatie ThermoFoam LTE +/- 16 cm. Rc: 4.85
				274, 	//Spouwmuurisolatie ThermoFoam LTE +/- 19 cm. Rc: 5,75
				282, 	//Spouwmuurisolatie ThermoFoam LTE +/- 3 cm. Rd: 0,91
				279, 	//Spouwmuurisolatie ThermoFoam LTE +/- 30 cm. Rc: 9.09
				224, 	//Spouwmuurisolatie ThermoFoam LTE +/- 4 cm. Rd: 1,21
				223, 	//Spouwmuurisolatie ThermoFoam LTE +/- 5 cm. Rd: 1,52
				222, 	//Spouwmuurisolatie ThermoFoam LTE +/- 6cm. Rd: 1,82
				225, 	//Spouwmuurisolatie ThermoFoam LTE +/- 7 cm. Rd: 2,12
				227, 	//Spouwmuurisolatie ThermoFoam LTE +/- 8 cm. Rd: 2.42
				229, 	//Spouwmuurisolatie ThermoFoam LTE +/- 9 cm. Rd: 2,73
			],
			vloerIsolatieProductIds: [
				325, 	//ThermoFloorÂ® Vloerisolatie / PIF ISO60 Rc 3,73
				196, 	//ThermoFloorÂ® Vloerisolatie / PIF ISO80 Rc 4,64
				142, 	//TonZon RC=5,0 m2K/W
			],
			impregnerenProductIds: [
				77
			]
		};
	},

	computed: {
		mainProductIds() {
			return [].concat(
				this.bodemIsolatieProductIds,
				this.ftx1ProductIds,
				this.leeghalenProductIds,
				this.thermofoamProductIds,
				this.vloerIsolatieProductIds,
				this.impregnerenProductIds
			);
		}
	},

	beforeMount() {
		this.getVans();
		this.mainProductProjectLine = this.projectMarker.projectLines.filter(projectLine => this.mainProductIds.includes(projectLine.product_id)).pop();
		this.projectLines = this.projectMarker.projectLines.filter(projectLine =>
			![45, 64, 102, 52, 320, 76, 308, 309, 61, 321, 56, 64, 332].includes(projectLine.product_id) &&
			!this.mainProductIds.includes(projectLine.product_id)
		);

		// For now only when main product is Leeghalen spouwmuren
		if (this.mainProductProjectLine.product_id === 331) {
			this.getAdditionalProjects();
		}

		this.isExternal = this.supportTicket != null && this.supportTicket.resolving_scope === 'EXTERNAL';
	},

	mounted() {
		if (this.isSupport === false) {
			this.notes = this.projectMarker.customfield_uitvoeringnotitie;
			this.currentHoogwerkerDate = this.projectMarker.customfield_hoogwerkeruitvoeringdatum;
		} else {
			this.notes = this.projectMarker.customfield_supportnotitie;
			this.externalFormData.external_date = this.projectMarker.customfield_uitvoeringservicedatum;
			this.currentHoogwerkerDate = this.projectMarker.customfield_supporthoogwerker;
		}
	},

	methods: {
		...mapActions({
			getProjectById: "projects/getProjectById",
			getFile: "files/fetchFiles"
		}),
		...mapMutations({
			removeProjectMarker: 'projects/removeProjectMarker'
		}),

		getVans() {
			let roles;

			if (this.isSupport) {
				roles = ["GROUND", "THERMO_FOAM","FTX1", "FLOOR", "SUPPORT", "IMPREGNEREN"];
			} else {
				if(this.projectMarker.additionalData != null) {
					switch (this.projectMarker.additionalData.product_type) {
						case 'FTX1':
							roles = ["FTX1", "SUPPORT"];
							break;
						case 'LEEGHALEN_SPOUWMUUR':
							roles = ["LEEGHALEN", "SUPPORT"];
							break;
						case 'THERMOFOAM':
							roles = ["THERMO_FOAM", "SUPPORT"];
							break;
						case 'VLOERISOLATIE':
							roles = ["FLOOR", "SUPPORT"];
							break;
						case 'BODEMISOLATIE':
							roles = ["GROUND", "SUPPORT"];
							break;
						case 'IMPREGNEREN':
							roles = ["IMPREGNEREN", "SUPPORT"];
							break;
						default:
							roles = ["SUPPORT"];
					}
				} else {
					// todo delete this legacy code
					switch (this.projectMarker.gripp_projectphase_id) {
						case 35:
							roles = ["GROUND", "SUPPORT"];
							break;
						case 28:
							roles = ["THERMO_FOAM", "SUPPORT"];
							break;
						case 54:
							roles = ["FTX1", "SUPPORT"];
							break;
						case 55:
						case 58:
							roles = ["FLOOR", "SUPPORT"];
							break;
						default:
							roles = ["SUPPORT"];
					}
				}
			}

			let queryData = {roles: roles};

			if (this.isReschedule === true) {
				// Make sure previously selected users are represented in the dropdowns for vans
				let userIds = [];
				for (const [key, appointment] of Object.entries(this.projectMarker.appointments)) {
					if (['PROJECT/UITVOERENDE_PLOEG', 'PROJECT/UITVOERENDE_PLOEG_EXTRA', 'PROJECT/VENTILATIE_ROOSTERS', 'PROJECT/IMPREGNEREN'].includes(appointment.type) &&
						!userIds.includes(appointment.user_id) &&
						appointment.user_id != null &&
						appointment.user_id.trim() !== '') {
						userIds.push(appointment.user_id);
					}
				}

				if (userIds.length > 0) {
					queryData = {
						...queryData,
						userIds: userIds
					};
				}
			}


			queryData.canInstallVentilatieroosters = this.projectMarker.projectLines.filter(projectLine => projectLine.product_id === 53).length > 0;

			client.query(`
				query($roles: [String], $userIds: [String], $canInstallVentilatieroosters: Boolean) {
					users(roles: $roles, userIds: $userIds, canInstallVentilatieroosters: $canInstallVentilatieroosters) {
						id
						display_name
						username
						can_install_ventilatieroosters
						role {
							constant
						}
					}
				}`,
				queryData
			).then(result => {
				this.vans = result.users.filter(user => user.can_install_ventilatieroosters === false);
				this.vansWithVentilatieroosters = result.users.filter(user => user.can_install_ventilatieroosters === true);
			}).catch(error => {
				console.log(error);
			});
		},

		getAdditionalProjects() {
			let productIds = [];
			if (this.mainProductProjectLine.product_id === 331) {
				productIds = this.ftx1ProductIds;
			}

			client.query(`
				query($id: ID, $company_id: ID, $product_ids: [Int]) {
					additionalProjectsByProductIds(id: $id, company_id: $company_id, product_ids: $product_ids) {
						id,
						projectLines {
							product_id
						}
					}
				}
			`, {
				id: this.projectMarker.id,
				company_id: this.projectMarker.company.id,
				product_ids: productIds
			}).then(result => {
				this.projectMarker.additionalProjects = result.additionalProjectsByProductIds;
			}).catch(error => {
				console.error(error);
			});
		},

		onSubmitMainForm(event) {
			event.preventDefault();

			this.$refs.submitMainButton.disable();

			const formData = this.validateMainForm();

			this.postMainForm(formData).then((result) => {
				if(result != null && result.errors != null && result.errors.length > 0) {
					throw result.errors;
				}

				this.$notify({
					group: 'app',
					title: 'Uitvoeringsafspraak maken',
					type: 'success',
					text: 'Afspraakbevestiging verstuurd',
				});
				this.$events.emit('executionAppointment/created');

				if (this.mainProductProjectLine.product_id === 331 && this.projectMarker.additionalProjects.length > 0 && this.shouldPlanFTX1 === true) {

					const ftx1ProjectId = this.projectMarker.additionalProjects.filter((project) => {
						return project.projectLines.filter((projectLine) => {
							return this.ftx1ProductIds.includes(projectLine.product_id);
						}).length > 0;
					}).pop();

					if (ftx1ProjectId) {
						this.getProjectById(ftx1ProjectId).then((project) => {

							this.getFile({
								company_id: project.company.id,
								type: "sales/voorkant"
							}).then(files => {

								this.$modal.show(ExecutionAppointmentCreateModal, {
									projectMarker: project,
									file: files[0],
									isReschedule: this.isReschedule,
									isSupport: false
								}, {
									classes: "modal",
									adaptive: true,
									scrollable: true,
									width: "100%",
									height: "auto",
									maxWidth: 1200
								});

							}).catch(error => {
								console.error(error);
							});

						});
					}
				}
			}).catch((error) => {
				this.$refs.submitMainButton.enable();
				
				if(error.hasOwnProperty("error") && error.error === "Form is not valid") {
					this.$notify({
						group: 'app',
						title: 'Uitvoeringsafspraak maken',
						type: 'error',
						text: 'Niet alle velden zijn correct ingevuld'
					});
					return;
				}

				this.handlePostError(error, formData);

				this.$notify({
					group: 'app',
					title: 'Uitvoeringsafspraak maken',
					type: 'error',
					text: 'Afspraak maken mislukt',
				});
			});
		},

		validateMainForm() {
			let areFormsValid = true;
			let formData = {
				notes: this.notes != null && this.notes !== '' ? this.notes : null
			};

			this.$refs.mainProjectLine.validateFields();
			if (this.$refs.mainProjectLine.errors.length > 0) {
				areFormsValid = false;
			}

			formData = Object.assign({}, formData, this.$refs.mainProjectLine.getFormValues());

			if (this.$refs.projectLines != null) {
				this.$refs.projectLines.forEach((projectLine) => {
					if (projectLine.hasFormData === false) {
						return;
					}

					projectLine.validateFields();

					if (projectLine.errors.length > 0) {
						areFormsValid = false;
						return;
					}

					formData = Object.assign({}, formData, projectLine.getFormValues());
				});
			}

			if (areFormsValid === false) {
				return null;
			}

			formData.main_project_id = this.projectMarker.id;

			return formData;
		},

		onSubmitExternalForm() {
			this.$refs.submitExternalButton.disable();

			const isValid = this.validateExternalForm();
			if (isValid === false) {
				this.$refs.submitExternalButton.enable();
				return;
			}

			const query = `
				mutation ($support_ticket_id: ID, $external_date: String, $notes: String) {
					saveExternalSupportTicketInfo(support_ticket_id: $support_ticket_id, external_date: $external_date, notes: $notes)
				}
			`;

			const postData = {
				support_ticket_id: this.supportTicket.id,
				external_date: this.externalFormData.external_date,
				notes: this.notes
			};

			client.query(query, postData).then((result) => {
				if(result.errors != null && result.errors.length > 0) {
					throw result.errors;
				}

				this.$notify({
					group: 'app',
					title: 'Support ticket updaten',
					type: 'success',
					text: 'Succesvol aangepast',
				});
				this.$events.emit('executionAppointment/created');
			}).catch((error) => {
				this.handlePostError(error, postData);

				this.$refs.submitExternalButton.enable();
				this.$notify({
					group: 'app',
					title: 'Uitvoeringsafspraak maken',
					type: 'error',
					text: 'Afspraak maken mislukt',
				});
			});
		},

		validateExternalForm() {
			if (this.externalFormData.external_date == null || this.externalFormData.external_date === '') {
				this.isExternalFormValid = false;
			} else {
				this.isExternalFormValid = true;
			}

			return this.isExternalFormValid;
		},

		postMainForm(formData) {
			return new Promise((resolve, reject) => {
				if (formData == null) {
					reject({error: 'Form is not valid'});
					return;
				}

				formData['reschedule'] = this.isReschedule;
				formData['support_ticket_id'] = this.supportTicket != null ? this.supportTicket.id : null;

				const query = `
				query (
					$main_project_id: ID!,
					$main_date_1: String!,
					$main_start_time_1: String!,
					$main_end_time_1: String!,
					$main_user_1: ID!,

					$main_date_2: String,
					$main_start_time_2: String,
					$main_end_time_2: String,
					$main_user_2: ID,

					$ventilatieroosters_date: String,
					$ventilatieroosters_start_time: String,
					$ventilatieroosters_end_time: String,
					$ventilatieroosters_user: ID,

					$date_hoogwerker: String,
					$extra_date_hoogwerker: String,

					$impregneren_project_id: ID,
					$impregneren_date: String,
					$impregneren_start_time: String,
					$impregneren_end_time: String,
					$impregneren_user: ID,

					$notes: String,

					$reschedule: Boolean,
					$support_ticket_id: ID
				) {
					createExecutionAppointment(
						main_project_id: $main_project_id,

						customfield_uitvoeringdatum: $main_date_1,
						customfield_begintijduitvoering2: $main_start_time_1,
						customfield_eindtijduitvoering2: $main_end_time_1,
						customfield_uitvoerendeploeg: $main_user_1,

						customfield_extrabusuitvoeringdatum: $main_date_2,
						customfield_extrabusuitvoeringbegintijd2: $main_start_time_2,
						customfield_extrabusuitvoeringeindtijd2: $main_end_time_2,
						customfield_extrabusuitvoeringbus: $main_user_2,

						customfield_ventilatieroostersuitvoeringdatum: $ventilatieroosters_date,
						customfield_ventilatieroostersuitvoeringbegintijd2: $ventilatieroosters_start_time,
						customfield_ventilatieroostersuitvoeringeindtijd2: $ventilatieroosters_end_time,
						customfield_ventilatieroostersuitvoeringbus: $ventilatieroosters_user,

						customfield_hoogwerkeruitvoeringdatum: $date_hoogwerker,
						extra_date_hoogwerker: $extra_date_hoogwerker,

						impregneren_project_id: $impregneren_project_id,
						customfield_impregnerenuitvoeringdatum: $impregneren_date,
						customfield_impregnerenuitvoeringbegintijd2: $impregneren_start_time,
						customfield_impregnerenuitvoeringeindtijd2: $impregneren_end_time,
						customfield_impregnerenuitvoeringbus: $impregneren_user,

						customfield_uitvoeringnotitie: $notes,

						reschedule: $reschedule
						support_ticket_id: $support_ticket_id
					) {
						id
					}
				}`;

				client.query(query, formData).then((result) => {
					this.removeProjectMarker(this.projectMarker.id);

					if ('impregneren_project_id' in formData) {
						this.removeProjectMarker(formData['impregneren_project_id']);
					}
					resolve(result);
				}).catch((error) => {
					console.error(error);
					reject(error);
				});
			});
		},

		setMainFormData(product, formData) {
			this.mainFormData[product] = JSON.parse(JSON.stringify(formData));
			this.shouldShowHoogwerkerWarning = this.checkShowHoogwerkerWarning();
		},

		checkShowHoogwerkerWarning() {
			let previousDate;
			if (this.isSupport === true) {
				previousDate = this.formatDate(this.projectMarker.customfield_supporthoogwerker, 'YYYY-MM-DD');
			} else {
				previousDate = this.formatDate(this.projectMarker.customfield_hoogwerkeruitvoeringdatum, 'YYYY-MM-DD');
			}

			let currentDate;
			if (this.mainFormData.hoogwerker.date_hoogwerker != null && this.mainFormData.hoogwerker.date_hoogwerker !== '') {
				currentDate = this.mainFormData.hoogwerker.date_hoogwerker;
			} else if (this.mainFormData.hoogwerker.extra_date_hoogwerker != null && this.mainFormData.hoogwerker.extra_date_hoogwerker !== '') {
				currentDate = this.mainFormData.hoogwerker.extra_date_hoogwerker;
			} else {
				currentDate = null
			}

			return 	previousDate != null && previousDate !== '' &&
				currentDate !== previousDate;
		},

		formatDate(date, format) {
			if (date != null && date !== '') {
				return moment(date).format(format);
			}

			return null;
		},

		handlePostError(error, formData) {
			client.query(`
				mutation($error: String $url: String, $context: String) {
					logError(error: $error, url: $url, context: $context)
				}
			`, {
				error: JSON.stringify(error, Object.getOwnPropertyNames(error)),
				context: JSON.stringify(formData),
				url: '/graphql/query/createExecutionAppointment',
			}).then(result => {
				if (result.logError !== true) {
					console.error('Error logging failed');
				}
			}).catch(error => {
				console.error('Error logging failed');
			});
		}
	}
}
</script>

<style scoped lang="scss">
.detail-section {
	grid-area: detail-section;

	display: flex;
	flex-direction: column;
}

.detail-section .header {
	font-weight: bold;
	padding: 24px;
	border-bottom: 2px solid #e5ebf0;
	border-top-right-radius: 3px;
	display: flex;
	justify-content: space-between;
}

.detail-section .header div {
	gap: 24px;
	display: flex;
	font-weight: normal;
}

.detail-section ::v-deep .item {
	margin-left: 24px;
	margin-right: 24px;
	padding: 24px 0;
}

.detail-section ::v-deep .item .item-title .title-detail {
	float: right;
}

.detail-section ::v-deep .item:last-of-type {
	border-bottom: none;
}

.detail-section .main-form {
	display: flex;
	flex-direction: column;
}

.detail-section .external-form {
	display: flex;
	padding-top: 24px;
	gap: 24px;

	textarea {
		width: 80%;
		margin: 0;
	}

	.input-container {
		width: 20%;

		> input, > select, ::v-deep > .DateField .DateField__group .TextField {
			border: 2px solid #ced6dd;
			border-radius: 5px;
			box-shadow: none;
			margin: 0 0 8px 0;
			padding: 0.5em;
			background: #FFF;
			font-size: 1rem;
		}

		::v-deep > .DateField .DateField__group .DateField__toggle {
			top: 0;
		}
	}
}

.detail-section textarea {
	padding: 10px;
	margin: 0 24px;

	border: 2px solid #ced6dd;
	border-radius: 5px;
	box-shadow: none;
	background: #FFF;
	font-size: 1rem;
}

.detail-section span.warning {
	margin-left: 24px;
	margin-right: 24px;
	padding: 5px;
	background-color: #f77c7c;
}

.form-actions {
	display: flex;
	align-items: center;
	align-self: flex-end;
	margin: 24px;

	.ToggleField {
		margin-left: 8px;
		margin-right: 24px;
	}

	.Button {
		display: block;
		border-radius: 5px;
		text-align: center;
		font-weight: bold;
		font-size: 1rem;
		text-decoration-line: none;
	}
}

.error-message {
	display: block;
	margin-top: 8px;
	color: red;
}
</style>
